@if (isCallbackRequest) {
<app-callback
  [@slideInOut]="true"
  [inCall]="true"
  [hover]="true"
  [interaction]="interaction()"
  (close)="closeCallbackPanel()"
>
</app-callback>
} @if (isCopied()) {
<div class="share-link-message fx-row fx-align-center" [@slideInOut]="true">
  <av-icon size="lg" mode="dark" name="tick"></av-icon>
  <span translate>Copied</span>
</div>
}

<av-tooltip message="Share video link" position="right" [enabled]="!shareOpen">
  <button
    [attr.aria-label]="
      (isShareToggleActive() ? 'Close' : 'Open') + ' link share menu'
        | translate
    "
    avButton
    ofType="icon"
    [size]="buttonSize"
    [color]="isShareToggleActive() ? 'basic' : 'primary'"
    class="room-control-min-size"
    id="btn-share-link-toggle"
    (click)="toggleShare()"
    data-tid="conference/toggle-share"
    [raised]="true"
    #menuButtonRef
  >
    @if (!isShareToggleActive()) {
    <av-icon name="link"></av-icon>
    } @if (isShareToggleActive()) {
    <av-icon name="close-big" mode="dark"></av-icon>
    }
  </button>
</av-tooltip>

@if (shareOpen()) {
<av-card
  [popup]="true"
  vAlign="top"
  [menu]="true"
  class="share-options"
  [@slideInOut]="true"
  #menuRef
>
  <av-card-header (close)="openChange(false)">
    {{ "Share your room link" | translate }}
  </av-card-header>
  <av-card-body>
    <av-menu>
      @if (isCustomerLinkAvailable) {
      <av-menu-item type="header">{{
        "Invite a customer" | translate
      }}</av-menu-item>
      @if (isSendChatWidgetAvailable) {
      <app-share-link-widget
        [interaction]="interaction()"
        [ticket]="customerTicket()"
        (completed)="completed()"
      ></app-share-link-widget>
      } @if (isSendChatAvailable) {
      <app-share-link-chat
        [interaction]="interaction()"
        [link]="customerLink()"
        (completed)="completed()"
        (openChange)="openChange($event)"
      ></app-share-link-chat>
      } @if (isQRCustomerAvailable) {
      <app-share-link-qr
        [interaction]="interaction()"
        [link]="customerLink()"
        (completed)="completed()"
        (openChange)="openChange($event)"
      ></app-share-link-qr>
      } @if (isEmailAvailable) {
      <app-share-link-email
        [interaction]="interaction()"
        [link]="customerLink()"
        (completed)="completed()"
        (openChange)="openChange($event)"
        (confirm)="confirmEmail($event)"
      ></app-share-link-email>
      } @if (isSMSAvailable) {
      <app-share-link-sms
        [interaction]="interaction()"
        [link]="customerLink()"
        (completed)="completed()"
        (openChange)="openChange($event)"
        (confirm)="confirmSMS($event)"
      ></app-share-link-sms>
      } @if (isCallbackAvailable) {
      <app-share-link-schedule
        (request)="callbackRequest()"
      ></app-share-link-schedule>
      }
      <av-menu-item
        icon="copy-document"
        (select)="copyCustomerLink()"
        [attr.aria-label]="'Copy customer link to clipboard' | translate"
        data-tid="conference/copy-customer-link"
        [postfix]="isTicketVisible() ? customerTicket() : undefined"
      >
        <span translate>Copy to clipboard</span>
      </av-menu-item>
      } @if (isAgentLinkAvailable) {
      <av-menu-item type="separator"></av-menu-item>
      <av-menu-item type="header">
        <span translate>Invite an agent</span>
      </av-menu-item>
      <av-menu-item
        icon="copy-document"
        (select)="copyAgentLink()"
        [attr.aria-label]="'Copy agent link to clipboard' | translate"
        data-tid="conference/copy-agent-link"
      >
        <span translate>Copy to clipboard</span>
      </av-menu-item>
      @if (isQRAgentAvailable) {
      <av-menu-item
        icon="barcode"
        (select)="showQR()"
        data-tid="conference/show-qr"
        [attr.aria-label]="'Show QR code' | translate"
      >
        <span translate>Show QR code</span>
      </av-menu-item>
      } }
    </av-menu>
  </av-card-body>
</av-card>
} @if (isPhoneNumberValidation) {
<app-share-link-sms-number
  [link]="customerLink()"
  [interaction]="interaction()"
  [queue]="smsQueue"
  [channel]="channel"
  [workflow]="workflow"
  (completed)="completed()"
  (dismiss)="isPhoneNumberValidation = false"
></app-share-link-sms-number>
} @if (isEmailValidation) {
<app-share-link-email-address
  [link]="customerLink()"
  [interaction]="interaction()"
  [queue]="emailQueue"
  [channel]="channel"
  [workflow]="workflow"
  (completed)="completed()"
  (dismiss)="isEmailValidation = false"
></app-share-link-email-address>
}

<input id="customer-link" type="hidden" [value]="customerLink()" />
<input id="agent-link" type="hidden" [value]="agentLink()" />
